import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { I18nService, phraseAppTranslationsLoader, TranslationsProvider } from '@recruitee/i18n';

import { appTranslations, uiTranslations, wysiwygTranslations } from '../locales';

@Injectable({ providedIn: 'root' })
export class OnboardingI18nResolver implements Resolve<boolean> {
  constructor(
    private i18n: I18nService,
    private i18nProvider: TranslationsProvider,
    private titleService: Title,
  ) {}
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.loadTranslation(route.params.lang);
  }

  public loadTranslation(lang: string): Promise<boolean> {
    return phraseAppTranslationsLoader(lang, this.i18n.locale, [
      appTranslations,
      uiTranslations,
      wysiwygTranslations,
    ]).then(translations => {
      this.i18nProvider.setTranslations(translations);
      this.i18n.locale = lang;
      this.titleService.setTitle(this.i18n.translate('rto.common.page_title'));
      return true;
    });
  }
}
